module.exports = __webpack_public_path__ + "media/images/profile-03-p-130x130q80-8ad3f1649c241d6fcce4b26e539c4cef.png";